import { BehaviorSubject } from 'rxjs';
import { TOKENS_DISTRIBUTION_CONFIG } from "../../config/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TokensDistributionService {
    constructor(http) {
        this.http = http;
        this.config = TOKENS_DISTRIBUTION_CONFIG;
        this.visible = new BehaviorSubject(null);
    }
    show() {
        this.visible.next(true);
    }
    hide() {
        this.visible.next(false);
    }
    getData() {
        return this.http.post(this.config.data, {});
    }
    saveBankInfo(routing, account) {
        return this.http.post(this.config.submit, { routing, account });
    }
    savePaypalInfo(email) {
        return this.http.post(this.config.savePaypalInfo, { email });
    }
    payout(amount) {
        return this.http.post(this.config.payout, { amount });
    }
}
TokensDistributionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TokensDistributionService_Factory() { return new TokensDistributionService(i0.ɵɵinject(i1.HttpClient)); }, token: TokensDistributionService, providedIn: "root" });
